import type { ParametersAbstractParameter, ParametersUnit } from "@/lib/api";

import type { TimeSeriesParameterOption } from "./time-series-parameter.types";

export function toTimeSeriesParameterOption(
  parameter: Pick<ParametersAbstractParameter, "id" | "label" | "units">,
): TimeSeriesParameterOption {
  return {
    id: parameter.id,
    label: parameter.label,
    units: parameter.units,
  };
}

export function unitDisplaySymbol(unit: ParametersUnit | undefined): string {
  if (!unit) return "";
  return unit.symbol ?? unit.name ?? unit.code;
}

export function primaryUnitSymbol(parameter: TimeSeriesParameterOption): string {
  return unitDisplaySymbol(parameter.units[0]);
}

export function resolveParameterUnitSymbol(
  parameter: TimeSeriesParameterOption,
  unitCode: string | undefined,
): string {
  if (unitCode) {
    const unit = parameter.units.find((candidate) => candidate.code === unitCode);
    if (unit) return unitDisplaySymbol(unit);
  }
  return primaryUnitSymbol(parameter);
}

export function resolveParameterUnit(
  parameter: TimeSeriesParameterOption,
  unitCode: string | undefined,
): ParametersUnit | undefined {
  if (unitCode) {
    const unit = parameter.units.find((candidate) => candidate.code === unitCode);
    if (unit) return unit;
  }
  return parameter.units[0];
}
